"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLengthUnder = void 0;
var isLengthUnder = function (value, length) {
    return value.length <= length;
};
exports.isLengthUnder = isLengthUnder;
//# sourceMappingURL=isLengthUnder.js.map